import { Box, Grid } from '@mui/material';
import FormView from '../../../../components/views/formView';
import { useProductForm } from './hook';
import { ProductData } from './data';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import {
    PRODUCT,
    PRODUCT_DETAIL,
    PRODUCT_NEW,
} from '../../../../../routes/paths';
import { ProductHistorical } from '../historical';

export const ProductForm = () => {
    const {
        product,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setFormikProductData,
        productHistorical,
        showHistorical,
        setShowHistorical,
    } = useProductForm();

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={
                    product && product.id ? 'Editar producto' : 'Crear producto'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={product?.id || ''}
                        buttonCreate={{
                            show: Boolean(product?.id),
                            route: PRODUCT_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PRODUCT,
                        }}
                        buttonView={{
                            show: true,
                            route: PRODUCT_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(product?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <ProductHistorical
                        historical={productHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <ProductData
                data={product}
                onChangeFormik={(formik) => setFormikProductData(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
